import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { resetPassword as resetPasswordApiCall } from "../api";
import Password from "../components/Password";
import { useAppContext } from "../context/AppContext";

export default function Reset() {
  const {
    state: {
      dictionary: { reset: contentfulData },
    },
    actions: { setMessage },
  } = useAppContext();

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  const { passwordResetKey, repDID } = params;
  let navigate = useNavigate();

  const [password1, set_password1] = useState("");
  const [password2, set_password2] = useState("");
  const [password1IsValid, set_password1IsValid] = useState(false);
  const [password2IsValid, set_password2IsValid] = useState(false);
  const [formIsValid, set_formIsValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const isSubmittingRef = useRef(false);
  const [
    text_resetPassword,
    text_pleaseFillOutForm,
    text_successMessage,
    text_failureMessage,
  ] = contentfulData;

  useEffect(() => {
    if (password1 === password2) set_password2IsValid(true);
    else set_password2IsValid(false);
  }, [password1, password2]);

  useEffect(() => {
    if (password1IsValid && password2IsValid) set_formIsValid(true);
    else set_formIsValid(false);
  }, [password1IsValid, password2IsValid]);

  function valueUpdate(newValue) {
    set_password1(newValue);
  }
  function handleConfirmPasswordChange(e) {
    const { value } = e.target;
    set_password2(value);
  }
  function resetPassword() {
    // Prevent multiple submissions with immediate check
    if (isSubmittingRef.current) return;
    
    // Set ref immediately to prevent race conditions
    isSubmittingRef.current = true;
    setIsLoading(true);
    
    console.log(repDID, passwordResetKey, password1, " sent to backend");
    resetPasswordApiCall(repDID, passwordResetKey, password1)
      .then((response) => {
        setMessage({ text: text_successMessage, type: "success" });
      })
      .catch(() => {
        setMessage({ text: text_failureMessage });
      })
      .finally(() => {
        navigate("/login");
      });
  }

  return (
    <section>
      <h1 className="text-center mb-40">{text_resetPassword}</h1>
      <div className="form-max flex-20 column">
        <p>{text_pleaseFillOutForm}</p>

        <Password
          isValid={set_password1IsValid}
          onChange={valueUpdate}
          value={password1}
          disabled={isLoading}
        />

        <ConfirmPassword onChange={handleConfirmPasswordChange} disabled={isLoading} />

        <div className="flex-20 mt-40 justify-center">
          <button 
            className={isLoading ? 'button-loading' : ''} 
            disabled={!formIsValid || isLoading} 
            type="button" 
            onClick={resetPassword}
          >
            <span className="button-text">{text_resetPassword}</span>
          </button>
        </div>
      </div>
    </section>
  );
}
function ConfirmPassword(props) {
  const {
    state: {
      dictionary: { password: contentfulData },
    },
  } = useAppContext();

  const { onChange, disabled } = props;
  const [hidden, set_hidden] = useState(true);
  const [text_password, text_show, text_hide] = contentfulData;
  return (
    <div className="password-wrapper">
      <div className="input-wrapper">
        <input
          id="password"
          name="password"
          type={hidden ? "password" : "text"}
          required
          onChange={onChange}
          disabled={disabled}
        />
        <label htmlFor="password" aria-label="password">
          {text_password}
        </label>
        <button
          type="button"
          id="passwordShow"
          onClick={(e) => set_hidden(!hidden)}
          disabled={disabled}
        >
          {hidden ? text_show : text_hide}
        </button>
      </div>
    </div>
  );
}
